import { faEdit } from "@fortawesome/pro-regular-svg-icons/faEdit";
import { Box } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { AccessKeys } from "app/appConstants";
import { CorePermissions } from "app/appPermissions";
import { PublicationType } from "generated/CoreApi_v1";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PublicationTypeName } from "views/knowledge/feed/components/PublicationTypeName";
import { publicationFactory } from "views/knowledge/feed/FeedHelpers";
import { CreateBatchPublication } from "views/knowledge/publication/creation/CreateBatchPublication";
import { HeaderLinkButton } from "./HeaderLinkButton";

/////////////////////////////////////////////////////////////////////////////////////////////////

type MenuOptions =
    | "post"
    | "list"
    | "question"
    | "poll"
    | "binder"
    | "batchPub";

interface IState {
    lastUpdate: Nullable<number>;
    open: boolean;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const HeaderPublisher: React.FC = () => {
    const session = useSession();
    const permissionExplorer = session.permissionExplorer;
    const { t } = useTranslation("shared");
    const [dialog, setDialog] = useState<React.ReactNode | null>(null);

    const [state, setState] = useState<IState>({
        lastUpdate: null,
        open: false,
    });

    ///
    function handleToggle() {
        setState({ ...state, open: !state.open });
    }

    ///
    function handleClose() {
        setState({ ...state, open: false });
    }

    ///
    const handleClosePublication = () => {
        setDialog(null);
    };

    ///
    function handleAction(action: MenuOptions) {

        switch (action) {
            case "list": {
                setDialog(publicationFactory(null, PublicationType.List, handleClosePublication, { isPublic: true }));
                break;
            }
            case "poll": {
                setDialog(publicationFactory(null, PublicationType.Poll, handleClosePublication));
                break;
            }
            case "post": {
                setDialog(publicationFactory(null, PublicationType.Post, handleClosePublication));
                break;
            }
            case "question": {
                setDialog(publicationFactory(null, PublicationType.Question, handleClosePublication));
                break;
            }
            case "binder": {
                setDialog(publicationFactory(null, PublicationType.Binder, handleClosePublication));
                break;
            }
            case "batchPub": {
                setDialog(<CreateBatchPublication onClose={() => setDialog(null)} />);
                break;
            }
        }

        setState({ ...state, open: false });
    }

    const getPublisherOptions = () => {
        var arr = [];
        arr.push(<MenuItem key="post" onClick={(e) => handleAction('post')}> <PublicationTypeName publicationType={PublicationType.Post} /></MenuItem>);
        arr.push(<MenuItem key="question" onClick={(e) => handleAction('question')}><PublicationTypeName publicationType={PublicationType.Question} /></MenuItem>);
        arr.push(<MenuItem key="binder" onClick={(e) => handleAction('binder')}><PublicationTypeName publicationType={PublicationType.Binder} /></MenuItem>);
        arr.push(<MenuItem key="poll" onClick={(e) => handleAction('poll')}><PublicationTypeName publicationType={PublicationType.Poll} /></MenuItem>);
        arr.push(<MenuItem key="list" onClick={(e) => handleAction('list')}><PublicationTypeName publicationType={PublicationType.List} /></MenuItem>);
        if (permissionExplorer.hasOne([CorePermissions.KnowledgeBatchPublisher])) {
            arr.push(<Box sx={{ mt: 1.5 }} key={`space_blank`} />);
            arr.push(<MenuItem key="batchPub" onClick={(e) => handleAction('batchPub')}>{t("App.Menu.Topbar.Publisher.BatchPublication")}</MenuItem>);
        }
        return arr;
    };

    ///
    return session.permissionExplorer.hasOne([CorePermissions.KnowledgePost])
        ? (
            <>
                {dialog}

                <HeaderLinkButton
                    accessKey={AccessKeys.UserMenu}
                    iconOrUrl={faEdit}
                    tooltip={t("App.Menu.Topbar.Publisher.Title")}
                    open={state.open}
                    handleClose={handleClose}
                    handleToggle={handleToggle}
                >
                    <MenuList role="menu" dense>
                        {getPublisherOptions()}
                    </MenuList>
                </HeaderLinkButton>
            </>
        )
        : null
        ;
};
